const homeAboutData = [
    {
        key: "AbhinavChoudhary",
        greeting: "Hi, My Name is...",
        name: "ABHINAV CHOUDHARY",
        role: "Full Stack Developer",
        aboutHeading: "About Me",
        aboutBody: [
            "I am a graduate student pursuing Masters in Software Engineering Systems @ Northeastern University, Boston",
            "I have 3+ years of work experience in web development technologies like Angular, React, Spring Boot, Java, SQL Server, Typescript, Azure, etc.",
            "I am organized, dependable and quick learner. Successful at managing multiple priorities with a positive attitude. Looking for a career which would demand most of my abilities for the betterment of the organization, whilst providing opportunities that would enable me to learn new things and help grow as a professional.",
            "I am currently seeking full-time opportunities in web and full stack development roles."
        ],
        resumeHeading: "Resume",
        resumeBody: [
            "Want a pdf version of the resume?"
        ],
        resumeDownloadText: "Download Resume"
    }
];

export default homeAboutData;